<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !quotationVisible">
      <div class="filter-container">
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
                v-model="listQuery.name"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">品牌</span>
            <el-input
                v-model="listQuery.brand"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
                v-model="listQuery.model"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">序列号</span>
            <el-input
                v-model="listQuery.serial"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务类型</span>
            <el-select :filterable="true" v-model="listQuery.type" class="filter-item" placeholder="" @keyup.enter="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in businessTypeOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">紧急程度</span>
            <el-select :filterable="true" v-model="listQuery.urgentId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @keyup.enter="handleFilter">
              <el-option
                v-for="item in urgentOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">客户公司</span>
            <el-input
              v-model="listQuery.customerCompanyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">客户联系人</span>
            <el-input
              v-model="listQuery.customerCompanyContactName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务员</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" remote clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @keyup.enter="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">工程师</span>
            <el-select :filterable="true" v-model="listQuery.engineerId" class="filter-item" placeholder="" remote clearable :size="t('table.btnSize')" @focus="handleEngineerFocus" @keyup.enter="handleFilter">
              <el-option
                v-for="item in engineerOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <el-button
              v-waves
              class="filter-item "
              type="primary"
              :size="t('table.btnSize')"
              @click="handleFilter"
            >
              {{ t("table.search") }}
            </el-button>
            <el-button
              v-permission="{ pkey: `${permissionName}_ADD` }"
              class="filter-item"
              type="primary"
              :size="t('table.btnSize')"
              @click="handleCommand('add')"
            >
              {{ t("table.add") }}
            </el-button>
            <el-button
              v-waves
              class="filter-item"
              :size="t('table.btnSize')"
              @click="handleReset"
            >
              {{ t("table.reset") }}
            </el-button>
          </div>
      </div>
      <TableList
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :page="listQuery.page"
        :size="listQuery.size"
        :tableName="TableName"
        :showSelection="true"
        :permissionName="permissionName"
        :canCommand="false"
        :canChangeColumn="false"
        @command-change="handleCommand"
      >
      </TableList>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { getUserDetailByUserId } from '@/apis/user'

import { UsersModel } from '@/model/userModel'

import { getDropdownByType } from '@/apis/tool'
import { ArrayRowsItem } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'

import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '../businessList/FieldFrom'
import { TableField } from '@/views/business/businessList/FieldTable'

import { defaultDate, pageVo } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  components: {
    TableList
  },
  props: {
    mode: { type: String, required: false },
    customerCompanyId: { type: Number, required: true },
    excludeIds: { type: Array, required: false, default: () => [] }
  },
  setup(props) {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName: TableName.TABLE_BUSINESS_LIST,
      permissionName: permissionName.BUSINESS_LIST,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      statusOption: [],
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      salesManOption: [],
      selectionArray: [],
      quotationVisible: false,

      handleCommand(command: string, val?: any) {
        console.log(command, 'command')
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'quotation':
            if (!dataMap.selectionArray.length) {
              return ElMessage.error({
                message: '请选择业务',
                type: 'success',
                duration: 1000
              })
            }
            dataMap.quotationVisible = true
        }
      },
      getList() {
        dataMap.listLoading = true
        console.log(props.excludeIds, 'props.excludeIds')
        getPageList('business', {
          ...dataMap.listQuery,
          pageType: 'QUOTE',
          customerCompanyId: props.customerCompanyId,
          excludeIds: props.excludeIds
        }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        getDetailById('business', row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = res[field.fieldKey]
              switch (field.fieldKey) {
                case 'model':
                  field.value = res.model ? res.model.split(',') : ''
                  break
                case 'customerCompanyContactId': {
                  const result = await getUrlList(field.config.url, { companyId: res.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: res.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(res.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('business', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleQuotatioSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/BusinessStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
        getUrlList('urgency/dropdown').then((res: any) => {
          dataMap.urgentOption = res || []
        })
        getUrlList('dropdown/BusinessType').then((res: any) => {
          dataMap.businessTypeOption = res || []
        })
      },
      handleEngineerFocus() {
        getUrlList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 2 && column.url) {
            getUrlList(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }

    })
    onMounted(() => {
      // dataMap.loadTableSelectOption()
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
<style  lang="scss">

</style>
